import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { cn } from "@/lib/utils";

interface DataTablePaginationProps {
  table: any;
}

function PaginatedControls({ table }: DataTablePaginationProps) {
  const pageCount = table.getPageCount();
  const currentPage = table.getState().pagination.pageIndex + 1;
  const maxVisible = 3

  if (pageCount <= 1) return null;

  const getPageNumbers = (): (number | string)[] => {
    const pages: (number | string)[] = [];
    const totalPages = pageCount;

    if (totalPages <= maxVisible + 2) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const windowSize = maxVisible;
    let start = currentPage - Math.floor(windowSize / 2);
    let end = currentPage + Math.floor(windowSize / 2);

    // Adjust if near the start
    if (start <= 2) {
      start = 2;
      end = 1 + windowSize;
    }

    // Adjust if near the end
    if (end >= totalPages - 1) {
      end = totalPages - 1;
      start = totalPages - windowSize;
    }

    pages.push(1); // first page

    if (start > 2) {
      pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages); // last page

    return pages;
  };

  const pages = getPageNumbers();
  const disabledPrev = !table.getCanPreviousPage();
  const disabledNext = !table.getCanNextPage();

  return (
    <Pagination className="mt-4">
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            aria-disabled={disabledPrev}
            className={cn("cursor-pointer rounded px-2 py-1 select-none")}
            onClick={() => !disabledPrev && table.previousPage()}
          />
        </PaginationItem>

        {pages.map((p, i) => {
          if (p === "...") {
            return (
              <PaginationItem key={`ellipsis-${i}`}>
                <PaginationEllipsis />
              </PaginationItem>
            );
          }

          const pageNumber = typeof p === "number" ? p : null;
          if (!pageNumber) return null;

          return (
            <PaginationItem key={pageNumber}>
              <PaginationLink
                key={i}
                className={`cursor-pointer select-none ${table.getState().pagination.pageIndex === pageNumber - 1 && "font-bold"}`}
                isActive={table.getState().pagination.pageIndex === pageNumber - 1}
                onClick={() => table.setPageIndex(pageNumber - 1)}
              >
                {pageNumber}
              </PaginationLink>
            </PaginationItem>
          );
        })}

        <PaginationItem>
          <PaginationNext
             aria-disabled={disabledNext}
            className={cn("cursor-pointer rounded px-2 py-1 select-none")}
            onClick={() => !disabledNext && table.nextPage()}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}

export default PaginatedControls













